import { Link } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { BRAND } from '../constants/brand';
import { PRODUCTS } from '../constants/products';
import ProductIcon from '../components/ProductIcon';

const ProductsIndex = () => {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />
      <main className="flex-1">
        <section className="relative overflow-hidden border-b border-slate-200 bg-mesh">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 pt-24 md:pt-28 pb-12 md:pb-16">
            <p className="text-sm font-semibold uppercase tracking-wider text-brand-violet mb-3">{BRAND.displayName}</p>
            <h1 className="font-display text-4xl md:text-5xl font-bold text-slate-900 tracking-tight mb-4">
              Apps on the App Store
            </h1>
            <p className="text-slate-600 text-lg max-w-2xl leading-relaxed">
              We ship focused iPhone apps—from health and creativity to reference and trivia. Tap a product to learn
              more and open it on the App Store.
            </p>
          </div>
        </section>

        <section className="max-w-6xl mx-auto px-4 sm:px-6 py-14 md:py-20">
          <ul className="grid gap-6 md:grid-cols-2">
            {PRODUCTS.map((p) => (
              <li key={p.slug}>
                <Link
                  to={`/products/${p.slug}`}
                  className="group flex h-full flex-col rounded-2xl border border-slate-200 bg-white p-6 shadow-card transition-all hover:border-brand-cyan/40 hover:shadow-brand"
                >
                  <div className="flex gap-4 mb-3">
                    <ProductIcon name={p.name} src={p.iconSrc} size="md" className="shrink-0" />
                    <div className="min-w-0">
                      <p className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-1">{p.category}</p>
                      <h2 className="font-display text-xl font-bold text-slate-900 group-hover:text-brand-violet transition-colors">
                        {p.name}
                      </h2>
                      <p className="text-sm text-brand-violet/90 font-medium mt-1">{p.tagline}</p>
                    </div>
                  </div>
                  <p className="text-slate-600 text-sm leading-relaxed flex-1 line-clamp-6">{p.summary}</p>
                  <span className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-brand-violet">
                    View product
                    <FiArrowRight className="transition-transform group-hover:translate-x-0.5" aria-hidden />
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default ProductsIndex;
